import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { Location } from "@/models/location.model"
export const useLocationStore = defineStore("locationStore", () => {
  const tenantBaseLocations: Ref<Location[]> = ref([])

  return {
    tenantBaseLocations
  }
})
